import React from "react";
import { makeStyles } from "@mui/styles";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardMedia from "@mui/material/CardMedia";
import clsx from 'clsx';
import { getMapImageUrl, getMapMetaById } from "../../constants/mapMeta";

const useStyles = makeStyles({
  root: {
    width: "100%",
    height: "14rem",
    borderRadius: 0,
  },
  media: {
    width: "10rem",
    height: "14rem",
  },
  borderLeft: {
    borderTopLeftRadius: 12,
    borderBottomLeftRadius: 12,
  },
  borderRight: {
    borderTopRightRadius: 12,
    borderBottomRightRadius: 12,
  },
});

export default function MapCard({ name }) {
  const classes = useStyles();
  const mapMeta = getMapMetaById(name);
  const imageUrl = getMapImageUrl(name);

  return (
      <Card
        className={clsx(classes.root, {
            [classes.borderLeft]: name === "de_mirage",
            [classes.borderRight]: name === "de_dust_ii",
        })}
      >
        <CardMedia
          className={classes.media}
          image={imageUrl || undefined}
          style={{
            backgroundImage: imageUrl ? `url(${imageUrl})` : "none",
            backgroundColor: imageUrl ? "transparent" : "rgba(255, 255, 255, 0.06)",
          }}
          title={mapMeta?.display || name}
        />
    </Card>
  );
}
